<template>
	<form @submit.prevent="save">
		<h5 class="has-text-weight-bold is-padded-bottom">
			{{ translations['form_introduction'] }}
		</h5>
		<div class="notification is-warning" v-if="this.hasOverlap">
			{{ translations['overlapping_period_warning'] }}
		</div>
		<div class="columns is-flex is-vcentered">
			<div class="column is-narrow">
				<div class="field">
					<div class="control label-around-input"
						 :class="{ 'is-danger': this.isSubmitted && !this.thePeriod.closed_from }">
						<label class="label">{{ translations['fields']['closed_from'] }}</label>
						<input type="date" class="input" v-model="thePeriod.closed_from" :min="minimumDate" :max="thePeriod.closed_until" />
					</div>
				</div>
			</div>
			<div class="column is-narrow">
				<div class="field">
					<div class="control label-around-input"
						 :class="{ 'is-danger': this.isSubmitted && !this.thePeriod.closed_until }">
						<label class="label">{{ translations['fields']['closed_until'] }}</label>
						<input type="date" class="input" v-model="thePeriod.closed_until" :min="thePeriod.closed_from || minimumDate" />
					</div>
				</div>
			</div>
		</div>
		<div class="field">
			<div class="control">
				<button class="button is-success" type="submit" :disabled="buttonsDisabled">
					{{ translations['buttons']['save'] }}
				</button>
				<button class="button is-light" type="reset" @click="cancel" :disabled="buttonsDisabled">
					{{ translations['buttons']['cancel'] }}
				</button>
			</div>
		</div>
	</form>
</template>

<script>
export default {
	name: "closing-days-form",
	props: [ 'period', 'translations', 'checkOverlap' ],
	emits: [ 'save', 'cancel' ],
	data()
	{
		return {
			isSubmitted: false,
			buttonsDisabled: false,
			thePeriod: this.period,
			minimumDate: moment().format('YYYY-MM-DD'),
		}
	},
	computed:
	{
		hasErrors()
		{
			return !this.thePeriod.closed_from || !this.thePeriod.closed_until;
		},
		hasOverlap()
		{
			return this.checkOverlap !== undefined
				&& this.checkOverlap !== null
				&& this.checkOverlap(
					this.thePeriod.closed_from,
					this.thePeriod.closed_until,
					this.thePeriod.id
				);
		}
	},
	methods:
	{
		save()
		{
			this.isSubmitted = true;
			if (this.hasErrors || this.hasOverlap)
			{
				return;
			}
			this.buttonsDisabled = true;
			this.$emit('save', this.thePeriod);
		},
		cancel()
		{
			this.buttonsDisabled = true;
			this.$emit('cancel');
		}
	}
}
</script>
